import React, { useContext } from 'react';

import './SupportLinks.scss';
import { LanguageContext } from '../../../context/language-context';

const SupportLinks = ({ className }) => {
  const lng = useContext(LanguageContext);

  return (
    <ul className={`support-links ${className}`}>
      <li>
        <a
          href="https://kentotakeuchi.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {lng.language === 'en' ? 'online store' : 'オンラインストア'}
        </a>
      </li>
      <li>
        <a
          href="https://squareup.com/us/en/gift-cards"
          target="_blank"
          rel="noopener noreferrer"
        >
          {lng.language === 'en' ? 'gift card' : 'ギフトカード'}
        </a>
      </li>
      <li>
        <a
          href="https://www.gofundme.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {lng.language === 'en' ? 'support us' : '竹内健人をサポート'}
        </a>
      </li>
    </ul>
  );
};

export default SupportLinks;
